import { DonutLargeRounded } from '@mui/icons-material';
import {
  Box,
  Button,
  Grid,
  Typography,
  useTheme,
} from '@mui/material';
import { Fragment } from 'react';
import Chart from 'react-apexcharts';
import MainCard from '../../../common/cards/MainCard';
import { transactionTypesChartProps } from '../../variables';
import ChartSkeleton from '../skeletons/ChartSkeleton';

export default function TransactionTypesChart({ isLoading, data }) {
  const theme = useTheme();

  if (isLoading) return <ChartSkeleton height={300} />;

  const grey200 = theme.palette.grey[200];
  const grey500 = theme.palette.grey[500];

  const primary200 = theme.palette.primary[200];
  const primaryDark = theme.palette.primary.dark;
  const secondaryMain = theme.palette.secondary.main;
  const secondaryLight = theme.palette.secondary.light;

  // Raw data for transactions.
  const transactions = data.listTransaction;

  // Auto-detect value of key and grouping object's data by this key.
  const groupBy = (items, key) =>
    items.reduce(
      (result, item) => ({
        ...result,
        [item[key]]: [...(result[item[key]] || []), item],
      }),
      {}
    );

  // Detect and group transactions by "transtypeid" key.
  const groupedTransaction = groupBy(transactions, 'transtypeid');

  // Get the labels by all difference "transtypeid" detected.
  const labels = Object.keys(groupedTransaction);

  // Matching series value to the labels (transtypeid).
  const series = labels.map((item) => {
    return groupedTransaction[item].length;
  });

  const renderTransactionTypesChartProps = { ...transactionTypesChartProps };
  renderTransactionTypesChartProps.options = {
    ...renderTransactionTypesChartProps.options,
    labels: labels,
    colors: [primary200, secondaryMain, primaryDark, secondaryLight],
    grid: {
      borderColor: grey200,
    },
    tooltip: {
      theme: 'light',
    },
    legend: {
      position: 'bottom',
      labels: {
        colors: grey500,
      },
    },
  };

  // Comment this line to render the example data
  renderTransactionTypesChartProps.series = series;

  return (
    <Fragment>
      <MainCard>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Grid container alignItems="center" justifyContent="space-between">
              <Grid item>
                <Grid container direction="column" spacing={1}>
                  <Grid item>
                    <Box sx={{ textAlign: 'left' }} height="40px">
                      <Button
                        endIcon={<DonutLargeRounded />}
                        sx={{ textAlign: 'left', ml: 1, cursor: 'default' }}
                        size="medium"
                      >
                        <Typography variant="h4">
                          Transactions types
                        </Typography>
                      </Button>
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Chart {...renderTransactionTypesChartProps} />
          </Grid>
        </Grid>
      </MainCard>
    </Fragment>
  );
}
